import React, { useState, useEffect, useRef, useCallback } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { saveNote, updateNote } from "../../services/api/NoteApi";
import "./NoteForm.scss";
import { useToast } from "../../context/ToastContext";
import { useAuth } from "../../context/AuthContext";
import { getBranchDetailsById } from "../../services/api/BranchApi";
import {
  getDistrictCasesByCourtRef,
  getHighCasesByCourtRef,
  getOtherCourtCasesAddedManuallyByCourtRef,
} from "../../services/api/CasesApi";

export const NoteForm = ({
  initialData: propInitialData,
  onSuccess,
  onCancel: propOnCancel,
  disabledCourtRef = false,
  isModal = false,
}) => {
  const { id } = useParams();
  const { company } = useAuth();
  const { state } = useLocation();
  const navigate = useNavigate();
  const { showToast } = useToast();
  const [branchesWithNames, setBranchesWithNames] = useState([]);
  console.log(company, "companyyy");
  console.log(company?.branches, "companyyy");
  const isEnt = company?.type === "ent";

  const initialData = state?.noteData || {};

  const [courtRef, setCourtRef] = useState(initialData.courtRef || "");
  const [title, setTitle] = useState(initialData.title || "");
  const [content, setContent] = useState(initialData.content || "");
  const [branchId, setBranchId] = useState(initialData.branchId || "");
  const [isSaving, setIsSaving] = useState(false);

  const isEdit = !!id;

  const [NoteisDropdownOpen, setNoteIsDropdownOpen] = useState(false);
  const [NoteselectedCourtTab, setNoteSelectedCourtTab] = useState("high");
  const [NoteCases, setNoteCases] = useState([]);
  const NotedropdownRef = useRef();
  const modalRef = useRef(null);

  // Add focus management refs and state
  const noteInputRef = useRef(null);
  const titleInputRef = useRef(null);
  const hasFocusedRef = useRef(false);
  const [initialDataLoaded, setInitialDataLoaded] = useState(false);

  // Add these state variables to your component
  const [noteSearchTerm, setNoteSearchTerm] = useState("");
  const [noteFilteredCases, setNoteFilteredCases] = useState(NoteCases);

  const [isLoadingCases, setIsLoadingCases] = useState(false);

  const handleCancel = useCallback(() => {
    if (propOnCancel) {
      propOnCancel();
    } else {
      navigate("/home/notes");
    }
  }, [propOnCancel, navigate]);

  // Add auto-focus effect
  useEffect(() => {
    // Prevent multiple focus attempts
    if (hasFocusedRef.current) return;

    // For editing mode, wait for initial data to load
    // For new note, focus immediately after component mounts
    const shouldFocus = isEdit ? initialDataLoaded : true;
    
    if (!shouldFocus) return;

    // Add a small delay to ensure DOM is ready
    const focusTimeout = setTimeout(() => {
      // Focus the appropriate field based on whether courtRef is disabled
      const targetInput = (disabledCourtRef && isModal && courtRef) ? titleInputRef.current : noteInputRef.current;
      
      if (targetInput && !hasFocusedRef.current) {
        targetInput.focus();
        
        // Move cursor to end of existing text (useful for edit mode)
        const val = targetInput.value || '';
        try {
          targetInput.setSelectionRange(val.length, val.length);
        } catch (e) {
          // Ignore selection range errors
        }
        
        hasFocusedRef.current = true;
      }
    }, 150);

    return () => clearTimeout(focusTimeout);
  }, [initialDataLoaded, isEdit, courtRef, title, disabledCourtRef, isModal]); // Add dependencies for data loading

  // Handle click outside modal to close
  useEffect(() => {
    const handleModalClickOutside = (event) => {
      if (isModal && modalRef.current && !modalRef.current.contains(event.target)) {
        handleCancel();
      }
    };

    if (isModal) {
      document.addEventListener('mousedown', handleModalClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleModalClickOutside);
    };
  }, [isModal, handleCancel]);

  useEffect(() => {
    // Filter cases based on search term and court tab
    // Ensure NoteCases is always an array
    let filtered = Array.isArray(NoteCases) ? NoteCases : [];

    // Filter by search term
    if (noteSearchTerm.trim()) {
      filtered = filtered.filter(
        (caseItem) =>
          caseItem.parties
            ?.toLowerCase()
            .includes(noteSearchTerm.toLowerCase()) ||
          caseItem.courtRef
            ?.toLowerCase()
            .includes(noteSearchTerm.toLowerCase()) ||
          caseItem.caseDate?.caseTypeAndNumber
            ?.toLowerCase()
            .includes(noteSearchTerm.toLowerCase())
      );
    }

    setNoteFilteredCases(filtered);
  }, [noteSearchTerm, NoteCases, NoteselectedCourtTab]);

  // Helper functions
  const getNoteDisplayValue = () => {
    if (noteSearchTerm && NoteisDropdownOpen) {
      return noteSearchTerm;
    }

    if (!courtRef) return "";

    const selected = NoteCases.find(
      (item) => String(item.courtRef).trim() === String(courtRef).trim()
    );
    return selected ? `${selected.courtRef}` : courtRef; // fallback if case not in fetched list yet
  };

  const handleNoteInputChange = (e) => {
    const value = e.target.value;
    setNoteSearchTerm(value);
    setNoteIsDropdownOpen(true);

    // Clear selection if user is typing
    if (value !== getNoteDisplayValue()) {
      setCourtRef("");
    }
  };

  const handleNoteInputFocus = () => {
    setNoteIsDropdownOpen(true);
    setNoteSearchTerm("");
  };

  const handleNoteCaseSelect = (caseItem) => {
    setCourtRef(caseItem.courtRef);
    setNoteSearchTerm("");
    setNoteIsDropdownOpen(false);
    console.log(caseItem.courtRef, "selected case");
  };

  const handleNoteKeyDown = (e) => {
    if (e.key === "Escape") {
      setNoteIsDropdownOpen(false);
      noteInputRef.current?.blur();
    } else if (e.key === "Enter" && noteFilteredCases.length === 1) {
      e.preventDefault(); // Prevent form submission
      handleNoteCaseSelect(noteFilteredCases[0]);
    }
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        NotedropdownRef.current &&
        !NotedropdownRef.current.contains(event.target)
      ) {
        setNoteIsDropdownOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const fetchNoteCases = async () => {
      setIsLoadingCases(true); // Start loading
      try {
        let response;
        if (NoteselectedCourtTab === "high") {
          response = await getHighCasesByCourtRef();
        } else if (NoteselectedCourtTab === "district") {
          response = await getDistrictCasesByCourtRef();
        } else if (NoteselectedCourtTab === "other") {
          response = await getOtherCourtCasesAddedManuallyByCourtRef();
        }

        setNoteCases(response?.data || []);
      } catch (err) {
        console.error("Error fetching cases:", err);
        setNoteCases([]); // Set empty array on error
      } finally {
        setIsLoadingCases(false); // Stop loading
      }
    };

    fetchNoteCases();
  }, [NoteselectedCourtTab]);

  useEffect(() => {
    const dataSource = propInitialData || (isEdit && state?.noteData);

    if (dataSource) {
      console.log(dataSource, "qqqqqqqqq");
      setCourtRef(dataSource.courtRef || "");
      setTitle(dataSource.title || "");
      setContent(dataSource.content || "");
      setBranchId(dataSource.branchId || "");
      setInitialDataLoaded(true); 
    } else {
      setInitialDataLoaded(true);
    }
  }, [isEdit, state, propInitialData]);

  useEffect(() => {
    const fetchBranchNames = async () => {
      if (!company?.branches || company.branches.length === 0) return;

      try {
        const fetchedBranches = await Promise.all(
          company.branches.map(async (id) => {
            const res = await getBranchDetailsById(id);
            console.log(res, "bbbbbbbb");
            return {
              id,
              name: res?.data?.result?.branchData?.branchName || id,
            };
          })
        );
        setBranchesWithNames(fetchedBranches);
      } catch (error) {
        console.error("Failed to fetch branch names", error);
      }
    };

    fetchBranchNames();
  }, [company?.branches]);

  // Add form validation function
  const isFormValid = () => {
    // Check required fields
    if (!courtRef || courtRef.trim() === "") return false;
    if (!title || title.trim() === "") return false;
    if (!content || content.trim() === "") return false;

    return true;
  };

  // Update the handleSubmit function
  const handleSubmit = async () => {
    if (!isFormValid()) {
      showToast("All required fields must be filled!", "error");
      return;
    }

    if (isSaving) return; // Prevent multiple submissions
    setIsSaving(true);

    try {
      const noteData = {
        courtRef,
        title,
        content,
        ...(isEnt && { branchId }),
      };

      // Get the note ID from either URL params or prop data
      const noteId = id || (propInitialData && propInitialData.id);

      if (isEdit && noteId) {
        await updateNote(noteData, noteId);
        showToast("Note updated successfully!", "success");
      } else {
        await saveNote(noteData);
        showToast("Note saved successfully!", "success");
      }


      // Handle success callback
      if (onSuccess) {
        onSuccess(courtRef);
      } else {
        // Clear form only if not using callback
        setCourtRef("");
        setTitle("");
        setContent("");
        // Navigate only if not in modal mode
        if (!isModal) {
          navigate("/home/notes");
        }
      }
    } catch (error) {
      console.error("Error saving/updating note:", error);
      showToast(`Failed to ${isEdit ? "update" : "save"} note`, "error");
    } finally {
      setIsSaving(false);
    }
  };

  // Enhanced Enter key submission handler
  const handleFormKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      const target = e.target;
      const tagName = target.tagName.toLowerCase();
      const className = target.className || "";

      // Don't submit if we're in certain elements that need Enter for their functionality
      if (tagName === "textarea" || 
          className.includes("notes-textarea") || 
          className.includes("custom-dropdown-input") ||
          target.closest('.dropdown-content')) {
        return;
      }

      // Prevent default form submission and submit manually if form is valid
      e.preventDefault();
      
      if (isFormValid() && !isSaving) {
        handleSubmit();
      }
    }
  };

  return (
    <div
      className={`notes-container ${isModal ? "modal-notes-container" : " "}`}
      ref={modalRef}
      onKeyDown={handleFormKeyDown}
    >
      <div
        className={`notes-form-wrapper ${isModal ? "modal-notes-form-wrapper" : " "}`}
      >
        <h1 className={`notes-title ${isModal ? "modal-notes-title" : " "}`}>
          {isEdit ? "Edit Note" : "New Note"}
        </h1>

        {isModal && (
          <button
            className="note-form-close-button"
            onClick={handleCancel}
            aria-label="Close"
          >
            &times;
          </button>
        )}

        <hr className="notes-divider" />

        <div className="notes-form">
          {/* Case Selection Section */}
          <div className="form-section">
            <h3>Case Information</h3>

            <div className="notes-form-group">
              <div className="case-selector" ref={NotedropdownRef}>
                <label className="notes-label">
                  Court Ref <span className="notes-required">*</span>
                </label>
                <input
                  ref={noteInputRef}
                  type="text"
                  value={getNoteDisplayValue()}
                  onChange={handleNoteInputChange}
                  onFocus={handleNoteInputFocus}
                  onKeyDown={handleNoteKeyDown}
                  className="custom-dropdown-input notes-input"
                  placeholder="Type to search cases..."
                  autoComplete="off"
                  disabled={disabledCourtRef && isModal && courtRef}
                />

                {NoteisDropdownOpen && !(disabledCourtRef && isModal && courtRef) && (
                  <div className="dropdown-content">
                    <div className="dropdown-tabs">
                      <button
                        type="button"
                        className={
                          NoteselectedCourtTab === "high" ? "active" : ""
                        }
                        onClick={() => setNoteSelectedCourtTab("high")}
                      >
                        High Court
                      </button>
                      <button
                        type="button"
                        className={
                          NoteselectedCourtTab === "district" ? "active" : ""
                        }
                        onClick={() => setNoteSelectedCourtTab("district")}
                      >
                        District Court
                      </button>
                      <button
                        type="button"
                        className={
                          NoteselectedCourtTab === "other" ? "active" : ""
                        }
                        onClick={() => setNoteSelectedCourtTab("other")}
                      >
                        Other Court
                      </button>
                    </div>
                    {/* <div className="dropdown-options">
                      {noteSearchTerm &&
                        (!Array.isArray(noteFilteredCases) ||
                          noteFilteredCases.length === 0) &&
                        Array.isArray(NoteCases) &&
                        NoteCases.length > 0 && (
                          <div className="no-data">
                            No cases found matching "{noteSearchTerm}"
                          </div>
                        )}


                      {(!Array.isArray(noteFilteredCases) ||
                        noteFilteredCases.length === 0) &&
                      !noteSearchTerm ? (
                        <div className="no-data">No cases found.</div>
                      ) : (
                        Array.isArray(noteFilteredCases) &&
                        noteFilteredCases.map((caseItem, index) => (
                          <div
                            key={index}
                            className={`dropdown-option ${
                              caseItem.courtRef === courtRef ? "selected" : ""
                            }`}
                            onClick={() => handleNoteCaseSelect(caseItem)}
                          >
                            <div className="case-info">
                              <div className="case-parties">
                                {caseItem.parties || "No parties info"}
                              </div>
                              <div className="case-ref">
                                {caseItem.courtRef}
                              </div>
                              {caseItem.caseDate?.caseTypeAndNumber && (
                                <div className="case-number">
                                  {caseItem.caseDate.caseTypeAndNumber}
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      )}
                    </div> */}
                    <div className="dropdown-options">
                      {isLoadingCases ? (
                        <div className="loading-state">Loading cases...</div>
                      ) : (
                        <>
                          {noteSearchTerm &&
                            (!Array.isArray(noteFilteredCases) ||
                              noteFilteredCases.length === 0) &&
                            Array.isArray(NoteCases) &&
                            NoteCases.length > 0 && (
                              <div className="no-data">
                                No cases found matching "{noteSearchTerm}"
                              </div>
                            )}

                          {(!Array.isArray(noteFilteredCases) ||
                            noteFilteredCases.length === 0) &&
                            !noteSearchTerm ? (
                            <div className="no-data">
                              No {NoteselectedCourtTab} court cases available
                            </div>
                          ) : (
                            Array.isArray(noteFilteredCases) &&
                            noteFilteredCases.map((caseItem, index) => (
                              <div
                                key={index}
                                className={`dropdown-option ${caseItem.courtRef === courtRef ? "selected" : ""}`}
                                onClick={() => handleNoteCaseSelect(caseItem)}
                              >
                                <div className="case-info">
                                  <div className="case-parties">
                                    {caseItem.parties || "No parties info"}
                                  </div>
                                  <div className="case-ref">
                                    {caseItem.courtRef}
                                  </div>
                                  {caseItem.caseDate?.caseTypeAndNumber && (
                                    <div className="case-number">
                                      {caseItem.caseDate.caseTypeAndNumber}
                                    </div>
                                  )}
                                </div>
                              </div>
                            ))
                          )}
                        </>
                      )}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>

          {/* Note Details Section */}
          <div className="form-section">
            <h3>Note Details</h3>

            <div className="notes-form-group">
              <label className="notes-label">
                Title <span className="notes-required">*</span>
              </label>
              <input
                ref={titleInputRef}
                type="text"
                className="notes-input"
                value={title}
                onChange={(e) => setTitle(e.target.value)}
                placeholder="Enter note title"
              />
            </div>

            <div className="notes-form-group">
              <label className="notes-label">
                Content <span className="notes-required">*</span>
              </label>
              <textarea
                className="notes-textarea"
                value={content}
                onChange={(e) => setContent(e.target.value)}
                placeholder="Enter note content"
              />
            </div>
          </div>

          {/* Branch Selection (Enterprise Only) */}
          {isEnt && (
            <div className="form-section">
              <h3>Branch Information</h3>

              <div className="notes-form-group">
                <label className="notes-label">
                  Branch
                </label>
                <select
                  className="notes-input"
                  value={branchId}
                  onChange={(e) => setBranchId(e.target.value)}
                  disabled={isEdit}
                >
                  <option value="">Select Branch</option>
                  {branchesWithNames.map((branch) => (
                    <option key={branch.id} value={branch.id}>
                      {branch.name}
                    </option>
                  ))}
                </select>
              </div>
            </div>
          )}

          <div className="notes-actions">
            <button
              className="notes-btn notes-btn-save"
              onClick={handleSubmit}
              disabled={!isFormValid() || isSaving}
            >
              {isSaving
                ? isEdit
                  ? "Updating..."
                  : "Saving..."
                : isEdit
                  ? "Update"
                  : "Save"}
            </button>
            <button
              className="notes-btn-cancel"
              onClick={handleCancel}
              disabled={isSaving}
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};